var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.84536 10.8337L14.5939 16.666L23.3152 4.45608C23.984 3.5198 25.2852 3.30295 26.2215 3.9717C26.4085 4.10533 26.5721 4.26899 26.7058 4.45608L35.4273 16.666L44.1756 10.8337C45.1331 10.1954 46.4265 10.4541 47.0648 11.4115C47.3392 11.8232 47.4581 12.3191 47.4004 12.8105L43.9771 41.9094C43.8535 42.9585 42.9644 43.7494 41.9079 43.7494H8.11313C7.05671 43.7494 6.1675 42.9585 6.04407 41.9094L2.62067 12.8105C2.48623 11.6678 3.30361 10.6325 4.44632 10.4981C4.93773 10.4402 5.43367 10.5592 5.84536 10.8337ZM25.0106 31.2494C27.3117 31.2494 29.1773 29.384 29.1773 27.0827C29.1773 24.7815 27.3117 22.9161 25.0106 22.9161C22.7094 22.9161 20.844 24.7815 20.844 27.0827C20.844 29.384 22.7094 31.2494 25.0106 31.2494Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldPlan);
export default __webpack_public_path__ + "static/media/gold-plan.9f3af7336e79b7003534328dc62b6c5f.svg";
export { ForwardRef as ReactComponent };